// extracted by mini-css-extract-plugin
module.exports = {"smallMarginY":"styles-module__smallMarginY___aCzO_","mediumMarginY":"styles-module__mediumMarginY___236eL","largeMarginY":"styles-module__largeMarginY___MNdAi"};